import React, { useRef } from "react";
import { Carousel } from "antd";

import { ChevronRight as RightArrow } from "@styled-icons/bootstrap";
import { ChevronLeft as LeftArrow } from "@styled-icons/bootstrap";

import { Root, Image, RightArrowButton, LeftArrowButton } from "./styles";

export const RoomPhotosCarousel: React.FC<{
  images: string[];
  className?: string;
}> = ({ images, className }) => {
  const carouselRef = useRef<any>(null);

  return (
    <Root className={className}>
      <Carousel ref={carouselRef}>
        {images.map((image, index) => (
          <Image
            src={image}
            key={index}
          />
        ))}
      </Carousel>
      {images.length > 1 ? (
        <>
          <LeftArrowButton
            onClick={(e) => {
              e.stopPropagation();
              carouselRef?.current?.prev?.();
            }}
          >
            <LeftArrow />
          </LeftArrowButton>
          <RightArrowButton
            onClick={(e) => {
              e.stopPropagation();
              carouselRef?.current?.next?.();
            }}
          >
            <RightArrow />
          </RightArrowButton>
        </>
      ) : null}
    </Root>
  );
};
